import { postJson } from "../config/fetch.api"
import OnboardingResponseBody from "./OnboardingResponseBody";

const postAuthorityToVerifyIdentity = async (authorityToVerifyIdentity: boolean): Promise<OnboardingResponseBody> =>
  postJson(
    Routes.api_onboarding_authority_to_verify_identity_path(),
    JSON.stringify({authority_to_verify_identity: authorityToVerifyIdentity}),
    true
  )

export default postAuthorityToVerifyIdentity;